import { SelectHTMLAttributes } from "react";
import styled, { css } from "styled-components";

export const FormLabel = styled.label<{ $textColor?: string }>`
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  color: ${(props) => props.$textColor || "var(--black)"};
  display: block;
  margin-bottom: 0.5rem;
  text-align: left;
`;

export const Select = styled.select<
  SelectHTMLAttributes<HTMLSelectElement> & { 
    $backgroundColor?: string, 
    $borderColor?: string, 
    $focusBorderColor?: string, 
    $textColor?: string,
  }
>`
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5rem;
  background: ${(props) => props.$backgroundColor || "var(--white)"};
  color: ${(props) => props.$textColor || "var(--black)"};
  padding: 0.5rem 3rem 0.5rem 0.5rem; /* Aumentado padding-right para 3rem */
  border-radius: 0.125rem;
  border: 1px solid ${(props) => props.$borderColor || "transparent"};
  display: block;
  height: 3.125rem;
  width: 100%;
  cursor: pointer;
  
  /* Remover a seta padrão do navegador */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  
  /* Adicionar seta personalizada maior */
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 1rem center; /* Posicionado a 1rem da direita */
  background-size: 1.25rem; /* Tamanho da seta aumentado para 1.25rem */

  &:focus {
    border-radius: 0.125rem;
    border: 2px solid ${(props) => props.$focusBorderColor || "var(--yellow-500)"};
    outline: none;
  }

  /* Estilo para option disabled (placeholder) */
  option:disabled {
    color: var(--gray-100);
    font-weight: 800;
  }

  /* Estilo para options normais */
  option:not(:disabled) {
    color: ${(props) => props.$textColor || "var(--black)"};
    font-weight: 500;
  }
`;

export const FormErrorMessage = styled.small`
  font-size: 0.75rem;
  line-height: 1.125rem;
  color: var(--red);
  margin-top: 0.25rem;
  display: block;
`;

export const FormControl = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isInvalid"].includes(prop),
})<{ isInvalid?: boolean }>`
  ${FormLabel} {
    ${(props) =>
      props.isInvalid &&
      css`
        color: var(--red);
      `};
  }

  ${Select} {
    ${(props) =>
      props.isInvalid &&
      css`
        border: 1px solid var(--red);
      `};

    &:focus {
      ${(props) =>
        props.isInvalid &&
        css`
          border: 1px solid var(--red);
        `};
    }
  }
`;
